import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {observable} from "mobx";
import {CoverageState} from "../CoverageState";
import FirebaseMyAccountFunctionsService
    from "../../../../services/firebase/functions/FirebaseMyAccountFunctionsService";
import {IAddPlanRequest} from "shared/functions/membersApi/types/IPlanRequests";

export class CoverageFormStore extends ApiCallObservable {
    @observable public files: any = {
        coveragePdfFile: ''
    };

    @observable public formInput: any = {};
    @observable public navigationController = {};
    @observable public showVerified: boolean = false;
    @observable private _currentScreen: CoverageState = CoverageState.financial;

    get currentScreen() {
        return this._currentScreen;
    };

    public updateScreen = (screen: CoverageState) => {
        this._currentScreen = screen;
    };

    public storeAccountDetails = (data: any) => {
        this.formInput.financial.bankInfo = data;
        this.addPlan();
    }

    public async addPlan() {
        try {
            const coverageParams: IAddPlanRequest = {
                planType: this.formInput.plans.plansValue,
                loanInfo: {
                    amount : parseInt(this.formInput.financial.amount, 10),
                    installmentPlan : this.formInput.financial.installmentPlan,
                    bankInfo: this.formInput.financial.bankInfo,
                    reason: this.formInput.financial.fundReason
                }
            };
            const response = await FirebaseMyAccountFunctionsService.addPlan(coverageParams);
            if (response.ok) {
                this.setSuccessfulResponse(response.data);
                this.showVerified = true;
                setTimeout(() => {
                    this.showVerified = false;
                    this.updateScreen(CoverageState.finish);
                }, 1700);
            } else {
                console.log(response);
                this.setError("Failed fetching summary");
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
        }
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/CoverageStore.ts